import PropTypes from 'prop-types';
import { TAG_INPUT_PROP_TYPES } from '../tag-input/types';

const { tags, invalid, ...restPropTypes } = TAG_INPUT_PROP_TYPES;

export const TAG_INPUT_FIELD_PROP_TYPES = {
  ...restPropTypes,
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
